import BusinessIcon from '@mui/icons-material/Business';
import RecyclingIcon from '@mui/icons-material/Recycling';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

const USE_CASES = [
  {
    slug: "empresa-de-consumo",
    number: "Caso 01",
    actor: "Empresa de consumo",
    summary: "Consolida su cumplimiento REP con información centralizada y validada.",
    Icon: BusinessIcon,
    solutionLink: "/soluciones#productores",
  },
  {
    slug: "gestor",
    number: "Caso 02",
    actor: "Gestor",
    summary: "Registra volúmenes y genera evidencia confiable para comercialización.",
    Icon: RecyclingIcon,
    solutionLink: "/soluciones#gestores",
  },
  {
    slug: "transformador",
    number: "Caso 03",
    actor: "Transformador",
    summary: "Certifica material transformado y respalda su operación.",
    Icon: PrecisionManufacturingIcon,
    solutionLink: "/soluciones#transformadores",
  },
];

export default USE_CASES;
